import type React from 'react';
import { useEffect, useState } from 'react';

const isEventInside = (containerRef: React.RefObject<HTMLElement>, e: PointerEvent) =>
  containerRef.current?.contains(e.target as Node) ?? false;

export function useClickOutside({
  containerRef,
  onClickOutside,
  disable,
  triggerOn,
}: {
  containerRef: React.RefObject<HTMLElement>;
  onClickOutside: (e: PointerEvent) => void;
  disable?: boolean;
  triggerOn?: 'pointerdown' | 'pointerup';
}) {
  const [isPointerDownInside, setIsPointerDownInside] = useState<boolean>(false);

  useEffect(() => {
    if (disable) {
      return;
    }

    document.addEventListener('pointerdown', handler, true);
    document.addEventListener('pointerup', handler, true);
    return () => {
      document.removeEventListener('pointerdown', handler, true);
      document.removeEventListener('pointerup', handler, true);
    };
  }, [disable, isPointerDownInside, onClickOutside]);

  function handler(e: PointerEvent) {
    const isEventInsideContainer = isEventInside(containerRef, e);

    if (e.type === 'pointerdown') {
      if (triggerOn === 'pointerdown' && !isEventInsideContainer) {
        onClickOutside(e);
        return;
      }
      setIsPointerDownInside(isEventInsideContainer);
      return;
    }

    if (e.type === 'pointerup' && !isEventInsideContainer && !isPointerDownInside) {
      onClickOutside(e);
      return;
    }
  }
}
